import { render, staticRenderFns } from "./fbradiobox.vue?vue&type=template&id=6039e2eb&"
import script from "./fbradiobox.vue?vue&type=script&lang=js&"
export * from "./fbradiobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports